import { render, staticRenderFns } from "./search-box.component.vue?vue&type=template&id=06a4853e&scoped=true"
import script from "./search-box.component.vue?vue&type=script&lang=ts"
export * from "./search-box.component.vue?vue&type=script&lang=ts"
import style0 from "./search-box.component.vue?vue&type=style&index=0&id=06a4853e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a4853e",
  null
  
)

export default component.exports